export default __webpack_public_path__ + "images/attachment_icon_vw.png";